module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ4AAAAsAgMAAADp6emWAAAADFBMVEV0aflzaPiAVf90afgsM4qNAAAAA3RSTlPtkAbDbqgCAAAANklEQVQ4y2OY/J8Y8CeBof4/UeACgz1xCg8w/CcOfBhVOKpwVOGowlGFI0EhsdUH0RUS0VUcAGyq0cmAOsqbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_bg2.png
// module id = n7iu
// module chunks = 167